import { PropertyGroupType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.SuiteSearch.ViewModels.PropertyGroupType */
export { PropertyGroupType };
import { PropertyGroupSubType } from "../../../../CoStar/Api/Maps/PropertyGroup/index.js";
/** CoStar.Api.SuiteSearch.ViewModels.PropertyGroupSubType */
export { PropertyGroupSubType };
